module.exports = __webpack_public_path__ + "static/media/criar deck.21845f01.png";